<template>
  <div class="p-info" :style="[baseStyles]">
    <span class="tangle" :style="[baseStyleBackground]"></span>
    <ProductImage :product="product"/>
    <div class="p-content">
      <ProductTitle :product="product"/>
      <ProductRate :product="product"/>
      <ProductDesc :product="product"/>
      <ProductPrice :product="product"/>
      <ProductButton :product="product"/>
    </div>
  </div>
</template>

<script>
import ProductImage from "./ProductImage";
import ProductTitle from "./ProductTitle";
import ProductDesc from "./ProductDesc";
import ProductRate from "./ProductRate";
import ProductPrice from "./ProductPrice";
import ProductButton from "./ProductButton";
export default {
  name: "ProductInfo",
  props: ["product"],
  components: {
    ProductImage,
    ProductTitle,
    ProductDesc,
    ProductRate,
    ProductPrice,
    ProductButton
  },
  computed: {
    baseStyles: function() {
      return {
        background: this.$store.state.front.settings.basicBackground,
        width: this.$store.state.front.settings.basicWidth + "px"
      };
    },
    baseStyleBackground: function() {
      return {
        borderColor: this.$store.state.front.settings.basicBackground
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.p-info {
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  box-shadow: 0px 0px 5px #bbb;
  padding: 5px;
  border-radius: 3px;
  max-width: 290px;
  width: 300px;
  left: 50%;
  transform: translate(-50%, 15px);
  position: absolute;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s, visibility .4s, transform 0.4s;
  z-index: 9999;
  color: #333;
  a {
    text-decoration: none;
  }
  .tangle {
    display: block;
    width: 0;
    height: 0;
    border-bottom: 8px solid #fff;
    border-left: 8px solid transparent !important;
    border-right: 8px solid transparent !important;
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}
.p-content {
  flex: 1 0 0;
}
.product-position-top {
  .__banner {
    .p-info {
      bottom: 100%;
      transform: translate(-50%, -15px);
      .tangle {
        border-bottom: none;
        border-top: 8px solid #fff;
        bottom: -8px;
        top: auto;
      }
    }
    .__product:hover,
    .__product.active {
      .p-info {
        transform: translate(-50%, -10px);
      }
    }
  }
}
.__product {
  &.active,
  &:hover {
    .p-info {
      opacity: 1;
      visibility: visible;
      transform: translate(-50%, 10px);
    }
  }
}
</style>

<style lang="scss">
.p-info {
  a {
    text-decoration: none !important;
  }
}
</style>